import variationPicker from "./variation-picker";

const variations = {
    "home-5": {
        showC2C: false,
        leadSource: "home-5",
        isIndexed: false,
        showBuyCarModule: false
    },
    "home-6": {
        showC2C: false,
        leadSource: "home-6",
        isIndexed: false,
        showBuyCarModule: true
    },
    default: {
        showC2C: true,
        leadSource: "original",
        isIndexed: true,
        showBuyCarModule: false
    }
};

export const homeVariation = (type) => variationPicker(type, variations);
